import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiService} from '@shared/services';
import {IApi} from '@entities/api';
import {IUpdatePayload, IUpdateResult} from '@entities/settings';

@Injectable({
  providedIn: 'root',
})
export class SettingsApi extends ApiService {
  public updateUser(
    payload: Partial<IUpdatePayload>
  ): Observable<IApi<IUpdateResult>> {
    return this.post<IApi<IUpdateResult>>(
      `${this.apiUrl}/users/update`,
      payload
    );
  }
}
